import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from './ui/alert-dialog';
import { AlertTriangle, Loader2 } from 'lucide-react';

export const ConfirmDeleteDialog = ({ open, onOpenChange, onConfirm, title, description, dependencies, loadingDeps }) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="confirm-delete-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-red-500" />
            {title || 'Confirmar eliminacion'}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {description || '¿Esta seguro que desea eliminar este elemento?'}
          </AlertDialogDescription>
        </AlertDialogHeader>

        {loadingDeps && (
          <div className="flex items-center gap-2 text-sm text-slate-500 py-2">
            <Loader2 className="w-4 h-4 animate-spin" />
            Verificando dependencias...
          </div>
        )}

        {!loadingDeps && dependencies && dependencies.length > 0 && (
          <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg" data-testid="dependency-warning">
            <p className="text-sm font-medium text-amber-800">Este elemento tiene dependencias:</p>
            <ul className="mt-1 text-sm text-amber-700 list-disc list-inside">
              {dependencies.map((dep, i) => <li key={i}>{dep}</li>)}
            </ul>
            <p className="mt-2 text-xs text-amber-600">
              Se eliminaran o desasociaran junto con este elemento.
            </p>
          </div>
        )}

        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-delete-cancel">Cancelar</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-red-500 hover:bg-red-600 text-white"
            disabled={loadingDeps}
            data-testid="confirm-delete-action"
          >
            Eliminar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
